import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "./MemberProfileModals.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";

type Props = {
  serviceUserName: string;
  visible: boolean;
  setVisibility: Function;
};

function RestrictedServiceUserRemovalModal({
  serviceUserName,
  visible,
  setVisibility,
}: Props) {
  const { width } = useWindowSize();

  function handleClose() {
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.restrictedServiceUserRemovalModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center">
          <Button className={styles.closeBtn} onClick={handleClose}>
            Close
          </Button>
        </Row>
      }
    >
      <Row justify="center" gutter={[0, 15]}>
        <Col className={styles.title}>Can't Remove Service User</Col>
        <Col span={24} />
      </Row>

      <Row justify="center" gutter={[0, 40]} className={styles.description}>
        <Col span={24}>
          <strong>{serviceUserName}</strong> has scheduled Upcoming Services and
          can't be removed at this time.
        </Col>

        <Col span={24}>
          To remove this service user, please cancel all of their Upcoming
          Services and then try again.
        </Col>
      </Row>
    </Modal>
  );
}

export default RestrictedServiceUserRemovalModal;
